export const CSS_CLASSES = {
  DRAWER_ROOT: "drawer",
  DRAWER_VISIBLE: "drawer-visible",
  DRAWER_OPEN: "drawer-open",

  DRAWER_SLIDE_FROM_LEFT: "drawer-slide-from-left",
  DRAWER_SLIDE_FROM_BOTTOM: "drawer-slide-from-bottom",
  DRAWER_SLIDE_FROM_RIGHT: "drawer-slide-from-right",

  DRAWER_EXTENSION_FULL: "drawer-extension-full",

  DRAWER_CONTENT_CONTAINER: "drawer-content-container",
  DRAWER_SLIDE_FROM_LEFT_CONTENT_CONTAINER: "drawer-slide-from-left-content-container",
  DRAWER_SLIDE_FROM_BOTTOM_CONTENT_CONTAINER: "drawer-slide-from-bottom-content-container",
  DRAWER_SLIDE_FROM_RIGHT_CONTENT_CONTAINER: "drawer-slide-from-right-content-container",

  DRAWER_SLIDING_CONTENT_CONTAINER: "drawer-sliding-content-container",
  DRAWER_FIXED_CONTENT_CONTAINER: "drawer-fixed-content-container",
  DRAWER_HANDLE_CONTAINER: "drawer-handle-container",
};
